import { render, staticRenderFns } from "./Form-pre-register.vue?vue&type=template&id=45596a54&"
import script from "./Form-pre-register.vue?vue&type=script&lang=js&"
export * from "./Form-pre-register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports